module.exports = __webpack_public_path__ + "media/images/illust/illust-g50s-36fe9c27502d7a0bd7de30ae99808f85.svg";